import * as React from "react";
const SvgMaterialAndColor = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "material_and_color_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "material_and_color_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "#fff" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.47 6.74V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v11.27a2 2 0 0 0 2 2h7.48V20a2 2 0 0 0 2 2H21a2 2 0 0 0 2-2V8.73a2 2 0 0 0-2-2ZM3 15.26V4h7.47v11.26ZM21 20h-8.53V8.74H21Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m15.92 11.44.97.94.97-.94.97.94.95-.91-.23-.22-.72.69-.97-.94-.97.94-.97-.94-.98.94-.71-.69-.23.22.94.91zM18.83 17.56l-.97-.94-.97.94-.97-.94-.98.94-.71-.69-.23.22.94.91.98-.94.97.94.97-.94.97.94.95-.91-.23-.22zM18.83 14.75l-.97-.94-.97.94-.97-.94-.98.94-.71-.69-.23.22.94.91.98-.94.97.94.97-.94.97.94.95-.91-.23-.22z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.22 6H9v1.6H4.22z",
	style: { fill: "#d35230" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.22 9.2H9v1.6H4.22z",
	style: { fill: "#4e9bd3" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.22 12.4H9V14H4.22z",
	style: { fill: "#f4c951" }
}))));
export default SvgMaterialAndColor;
